var _style, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C36F51;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.5,116.9V63c0-5.5-4.4-9.9-9.9-9.9H78.4c-5.5,0-9.9,4.4-9.9,9.9v53.9c0,5.5,4.5,9.9,9.9,9.9h23.2 C107.1,126.9,111.5,122.4,111.5,116.9z M101.6,123.5H78.4c-3.6,0-6.6-3-6.6-6.6V63c0-3.6,3-6.6,6.6-6.6h23.2c3.6,0,6.6,3,6.6,6.6 v53.9C108.2,120.5,105.3,123.5,101.6,123.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 88.7,
    cy: 113.6,
    r: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateDevice);
export default __webpack_public_path__ + "static/media/rotate_device.fa20b20d14b52ea2dd58ab62375f0031.svg";
export { ForwardRef as ReactComponent };